module.exports = __webpack_public_path__ + "img/noti-error.01c8c9b7.svg";